import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from '@itds/elements/index.js';

const Toolbar = ({ buttons, onSearch, placeholder }) => {
  const styles = {
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '40px'
    },
    toolbar_search: { width: '30%', position: 'relative' },
    toolbar_search_input: { width: '100%', position: 'relative', zIndex: 1 },
    toolbar_search_autocomplete: {
      zIndex: 1,
      display: 'none',
      position: 'absolute',
      background: '#fff',
      width: '100%',
      border: '1px solid #e5e5e5',
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1)',
      maxHeight: '300px',
      overflow: 'auto'
    },
    toolbar_search_autocomplete_a: {
      display: 'block',
      padding: '10px',
      borderBottom: '1px solid #f5f5f5',
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    toolbar_search_scrim: {
      display: 'none',
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0'
    },
    toolbar_actions: { display: 'flex' }
  };

  return (
    <div style={styles.toolbar}>
      {onSearch ? (
        <Input onKeyDown={onSearch} placeholder={placeholder} style={{ width: 400 }} type='text' />
      ) : (
        <div />
      )}

      {buttons ? (
        <div style={styles.toolbar_actions}>
          {buttons?.map((button, i) => {
            return (
              <Button
                color={button?.color}
                key={i}
                onClick={button?.onClick}
                style={{ marginLeft: 4 }}
                to={button?.to || ''}
              >
                {button.label}
              </Button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

Toolbar.propTypes = {
  buttons: PropTypes.array,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  placeholder: PropTypes.string
};

export default Toolbar;
